/*
The content of this file was produced with the help of a code generation tool and subsequently reviewed and edited by a human.

While some of the code was created by an AI assisted service, manual adjustments have been made to ensure correctness, readability, functionality and compliance to Avalara's coding standards and guidelines.

Any future modifications should be approached with caution to avoid overwriting the manual changes.
This source code is owned by Avalara Inc. Unauthorized copying of this file, via any medium, is strictly prohibited. Proprietary and confidential.

For more information, refer to the documentation or contact the development team.
*/

import { createStore } from '@stencil/store';
import { IntlShape } from '@formatjs/intl';
import { createIntlObject, getLocale } from './utils/i18n';
import { StringMap } from './types/types';

export interface AppState {
  intl: Promise<IntlShape>;
  locale: string;
  appMessages: StringMap | undefined;
  theme: {
    direction: 'ltr' | 'rtl';
  };
}

export const { state, onChange } = createStore<AppState>(() => ({
  intl: createIntlObject(getLocale()),
  locale: getLocale(),
  appMessages: undefined,
  theme: {
    direction: 'ltr',
  },
}));

// i18n related changes
onChange('locale', value => {
  state.intl = createIntlObject(value);
});

onChange('appMessages', value => {
  state.intl = createIntlObject(state.locale, value);
});

// Theme related changes
onChange('theme', value => {
  if (value.direction) {
    document.documentElement.dir = value.direction;
  }
});

// Theme helper functions
export const setThemeDirection = (direction: 'ltr' | 'rtl') => {
  state.theme = { ...state.theme, direction };
};
